
"use client";

// This file is specifically for client-side configuration.
// It ensures that Next.js correctly bundles the environment variables for the browser.

export const firebaseClientConfig = {
  apiKey: "AIzaSyAc3Lp8ZhvGGChYJSWnTRWHww3MOwGoTTE",
  authDomain: "barcade-manager.firebaseapp.com",
  projectId: "barcade-manager",
  storageBucket: "barcade-manager.appspot.com",
  messagingSenderId: "907570376685",
  appId: "1:907570376685:web:667a8ce53e67e0fe6441e4"
};
